import { AFDataObject, AFMessageType } from ".";

export enum AlertType {
  AF_RANK = 'AF_RANK',
  HIGH_VALUE_TARGET_MENTION = 'HIGH_VALUE_TARGET_MENTION',
  TWEET_COUNT = 'TWEET_COUNT',
  DEXSCREENER_CTO = 'DEXSCREENER_CTO',
  DEXSCREENER_BOOST = 'DEXSCREENER_BOOST',
}

export interface FeTokenAlertRawData {
  description: string;
  type: AlertType;
}

export interface FeTokenAlertStateData extends FeTokenAlertRawData {
  lastUpdated: Date;
}

export class FeTokenAlert implements AFDataObject<FeTokenAlertRawData, FeTokenAlertStateData> {
  public description: string;
  public type: AlertType;
  public lastUpdated: Date;

  constructor(data: FeTokenAlertRawData | null, lastUpdated?: Date) {
    this.description = data?.description || '';
    this.type = data?.type || AlertType.AF_RANK;
    this.lastUpdated = new Date(lastUpdated || 0);
  }

  static create(data: FeTokenAlertRawData | null, lastUpdated?: Date): FeTokenAlert {
    return new FeTokenAlert(data, lastUpdated);
  }

  getMessageType(): AFMessageType {
    return AFMessageType.FE_TOKEN_ALERT;
  }

  toRawData(): FeTokenAlertRawData {
    return {
      description: this.description,
      type: this.type,
    };
  }

  toStateData(): FeTokenAlertStateData {
    return {
      ...this.toRawData(),
      lastUpdated: this.lastUpdated,
    };
  }

  filter(existingData: FeTokenAlertStateData): boolean {
    return Number(this.lastUpdated) > Number(existingData.lastUpdated);
  }
}

